import { ChevronLeft } from 'lucide-react'
import { useAppStore } from '@/store/app'
import styles from './ChatView.module.css'

/**
 * Стрелка «назад» в шапке содержимого: на телефоне возвращает к списку каналов.
 * На широком экране список и так рядом, и кнопка скрыта стилями, а не условием —
 * так она не мигает при повороте. onBack — если «назад» ведёт не к списку, а куда-то ещё.
 */
export function MobileBack({ label = 'К списку каналов', onBack }: { label?: string; onBack?: () => void }) {
  const showNav = useAppStore((s) => s.showNav)
  return (
    <button type="button" className={styles.back} aria-label={label} data-tooltip={label} onClick={onBack ?? showNav}>
      <ChevronLeft size={26} />
    </button>
  )
}
